module.exports = __webpack_public_path__ + "img/icon-profile-black.e65760c9.svg";